// export default ProjectBug;
import React, { useEffect, useState } from "react";
import "./ProjectBug.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  setBugSummary,
  setIsBugSummaryModal,
} from "../../store/slice/bugSlice";
import { getBugSummary } from "../../services/homeService";
import EmptyState from "../EmptyState/EmptyState";
import BugTable from "../../pages/BugList/BugTable";
import BugSummary from "../../pages/BugList/BugSummary";
import BugDashboard from "../../pages/BugDashboard/BugDashboard";
import CircularProgress from '@mui/material/CircularProgress';

const ProjectBug = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  // Add local loading state
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  
  const { selectedProjectBugs, isBugSummaryModal, isBugDashboard, loading } =
    useSelector((state) => state.bugDetails);

  // Initial load effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 1000); // Show loading for at least 1 second

    return () => clearTimeout(timer);
  }, []);

  const getBugSummaryApi = async () => {
    try {
      const resp = await getBugSummary();
      dispatch(setBugSummary(resp));
    } catch (error) {
      console.error("Error fetching bugs summary:", error.message);
    }
  };

  const handleAddBugs = () => {
    dispatch(setIsBugSummaryModal(true));
    getBugSummaryApi();
  };

  const handleClose = () => {
    dispatch(setIsBugSummaryModal(false));
  };

  // Display bug dashboard if that mode is active
  if (isBugDashboard) {
    return <BugDashboard />;
  }

  // Display bug summary modal if active
  if (isBugSummaryModal) {
    // Extract subtask information from location state if available
    const subtaskId = location.state?.subtaskId;
    const subtaskName = location.state?.subtaskName;
    const subtaskSummary = location.state?.subtaskSummary;
    
    console.log("Subtask info in ProjectBug:", { subtaskId, subtaskName, subtaskSummary });
    
    return (
      <BugSummary 
        handleClose={handleClose}
        subtaskId={subtaskId}
        subtaskName={subtaskName}
        subtaskSummary={subtaskSummary}
      />
    );
  }

  // During initial load, show loading indicator
  if (isInitialLoading) {
    return (
      <div className="loader">
        <CircularProgress />
      </div>
    );
  }

  // Always render BugTable, even if the list is empty
  // This ensures that the BugTable's useEffect can run and fetch the data
  // BugTable will handle its own loading state based on the Redux loading state
  return <BugTable bugsList={selectedProjectBugs || []} loading={loading} />;
};

export default ProjectBug;